import {ReportLegalConcernFormRequest_Reason} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {useMemo} from 'react';

export const useGetReportReasons = () => {
  const {t} = useTranslation();

  return useMemo(
    () => [
      {
        label: t('Infringement of intellectual property rights'),
        value: ReportLegalConcernFormRequest_Reason.INFRINGEMENT_OF_IP,
      },
      {
        label: t('Incorrect or missing product or merchant information'),
        value: ReportLegalConcernFormRequest_Reason.INCORRECT_INFO,
      },
      {
        label: t('Inappropriate content'),
        value: ReportLegalConcernFormRequest_Reason.INAPPROPRIATE_CONTENT,
      },
      {
        label: t('Non-compliance with ABOUT YOU terms of use or policies'),
        value: ReportLegalConcernFormRequest_Reason.NON_COMPLIANT,
      },
      {
        label: t('Product safety'),
        value: ReportLegalConcernFormRequest_Reason.PRODUCT_SAFETY,
      },
      {
        label: t('Any other legal offence'),
        value: ReportLegalConcernFormRequest_Reason.OTHER_LEGAL_OFFENSE,
      },
    ],
    [],
  );
};
